import React from "react";
// import mous from "../../assets/images/ss-mous.jpg";
// import { Link } from "react-router-dom";
import icon_image from "../../assets/Icon-2.gif"
import icon_image1 from "../../assets/Icon-3.gif"
// import icon_image2 from "../../assets/Icon-7.gif"

const VisionMision = () => {
  return (
    <div>
      <div className="container">
        <div className="Home-box">
          <div className="Home-boxes1">
          <img src={icon_image} height={"100px"} width={"100px"}></img>
          <h5 className="mb-1 mt-2">Vision</h5>
          <p style={{ textAlign: "justify" , padding:"12px"}}>
                  To make the students achieve highest standards of quality
                  technical education adaptable to suit the present day
                  requirements in the fields of science and technology and to
                  mould them morally into persons of character and integrity.
                </p>
          </div>
          <div className="Home-boxes2">
          <img src={icon_image1} height={"100px"} width={"100px"}></img>
            <h5 className="mb-1 mt-2">Mission</h5>
            <p style={{ textAlign: "justify", padding:"12px" }}>
                  To awaken the students to the reality of identifying their
                  hidden potentials and talents through meticulous and
                  systematic grooming to gain the spirit and inventiveness to
                  build a career full of glorious prospects and eventful future.
                </p>
          </div>
     
        </div>
        </div>

      {/* <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5">
            <div
              className="col-lg-6 wow fadeInUp"
              data-wow-delay="0.1s"
              style={{ minHeight: "400px" }}
            >
              <div className="position-relative h-100">
                <img
                  className="img-fluid position-absolute w-100 h-130"
                  src={mous}
                  alt="about-img"
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
              <h6 className="section-title bg-white text-start text-primary pe-3">
                OUR MOUs
              </h6>
              <h1 className="mb-4">Memorandum Of Understanding</h1>
              <div className="row gy-2 gx-4 mb-4">
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2"></i>
                    Microsoft Windows
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2"></i>
                    CISCO Networking Academy
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2"></i>
                    TASK(Telangana Academy for Skill and Knowledge)
                  </p>
                </div>
                <br />
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2"></i>
                    Wipro
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2"></i>
                    ESwetcha
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2"></i>
                    Campus Connect
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2"></i>
                    Oracle Academy
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2"></i>
                    Mission 10X
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default VisionMision;
